import { FORM_FIELDS, FORM_FIELDS_NAMES } from '../new-application/new-application-form';
import { ISelectorData } from '../../components/application/NewApplication';
import { ILists } from '../../interfaces/merchant';
import { TFunction } from 'react-i18next';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';

export const yesNoList = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];

interface ICompanyInputsProps {
  mccList: ISelectorData[];
  lists: ILists;
  t: TFunction;
}

export const APP_VIEW_COMPANY_INPUTS = ({ t, lists, mccList }: ICompanyInputsProps): IFormInputProps[] => [
  {
    key: FORM_FIELDS.COMPANY_NAME,
    fieldName: FORM_FIELDS.COMPANY_NAME,
    placeholder: t(FORM_FIELDS_NAMES.COMPANY_NAME),
    label: t(FORM_FIELDS_NAMES.COMPANY_NAME),
    inputType: InputType.Text,
    required: true,
  },
  {
    key: FORM_FIELDS.DOING_BUSINESS,
    fieldName: FORM_FIELDS.DOING_BUSINESS,
    placeholder: t(FORM_FIELDS_NAMES.DOING_BUSINESS),
    label: t(FORM_FIELDS_NAMES.DOING_BUSINESS),
    inputType: InputType.Text,
    required: true,
  },
  {
    key: FORM_FIELDS.TAX,
    fieldName: FORM_FIELDS.TAX,
    placeholder: t(FORM_FIELDS_NAMES.TAX),
    label: t(FORM_FIELDS_NAMES.TAX),
    inputType: InputType.Text,
    required: true,
  },
  {
    key: FORM_FIELDS.IS_BASED_IN_US,
    fieldName: FORM_FIELDS.IS_BASED_IN_US,
    placeholder: t(FORM_FIELDS_NAMES.IS_BASED_IN_US),
    label: t(FORM_FIELDS_NAMES.IS_BASED_IN_US),
    inputType: InputType.Select,
    data: yesNoList,
    cleanable: false,
    searchable: false,
    isLabelIcon: true,
    tooltipText: t(FORM_FIELDS_NAMES.IS_BASED_IN_US_TOOLTIP),
    required: true,
  },
  // {
  //   key: FORM_FIELDS.BUSINESS_TYPE,
  //   fieldName: FORM_FIELDS.BUSINESS_TYPE,
  //   placeholder: t(FORM_FIELDS_NAMES.BUSINESS_TYPE),
  //   label: t(FORM_FIELDS_NAMES.BUSINESS_TYPE),
  //   inputType: InputType.Select,
  //   // required: true,
  //   dataCy: 'business_type',
  //   data: lists.businessTypes,
  // },
  // {
  //   key: FORM_FIELDS.TIME_IN_BUSINESS,
  //   fieldName: FORM_FIELDS.TIME_IN_BUSINESS,
  //   label: t(FORM_FIELDS_NAMES.TIME_IN_BUSINESS),
  //   placeholder: t(FORM_FIELDS_NAMES.TIME_IN_BUSINESS),
  //   inputType: InputType.Select,
  //   data: lists.timeInBusiness,
  //   searchable: false,
  // },
  // {
  //   key: FORM_FIELDS.PLATFORM_USAGE_PERIOD,
  //   fieldName: FORM_FIELDS.PLATFORM_USAGE_PERIOD,
  //   label: t(FORM_FIELDS_NAMES.PLATFORM_USAGE_PERIOD),
  //   tooltipText: t(FORM_FIELDS_NAMES.PLATFORM_USAGE_PERIOD_TOOLTIP),
  //   isLabelIcon: true,
  //   inputType: InputType.Select,
  //   data: lists.timeInBusiness,
  //   searchable: false,
  //   required: true,
  // },
  {
    key: FORM_FIELDS.MCC,
    fieldName: FORM_FIELDS.MCC,
    placeholder: t(FORM_FIELDS_NAMES.MCC),
    label: t(FORM_FIELDS_NAMES.MCC),
    inputType: InputType.Select,
    data: mccList,
    required: true,
  },
  // {
  //   key: FORM_FIELDS.WEB_URL,
  //   fieldName: FORM_FIELDS.WEB_URL,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(FORM_FIELDS_NAMES.WEB_URL)}`,
  //   label: t(FORM_FIELDS_NAMES.WEB_URL),
  //   inputType: InputType.Website,
  //   required: true,
  // },
  {
    key: FORM_FIELDS.DESCRIPTOR,
    fieldName: FORM_FIELDS.DESCRIPTOR,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(FORM_FIELDS_NAMES.DESCRIPTOR)}`,
    label: t(FORM_FIELDS_NAMES.DESCRIPTOR),
    inputType: InputType.Text,
    required: true,
  },
];
